module.exports = __webpack_public_path__ + "img/default-avatarl.fb3e7099.jpg";